/* eslint-disable react/prop-types,no-shadow */
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button, Icon } from 'antd';
import { Panel } from 'components/ui/index';
import PERMISSIONS from 'config/app-permission.config';
import { setTeams } from 'store/global/action';
import { updateUsers } from 'views/Setup/Users/flow/action';
import { Permission } from 'components/page/index';
import {
  setEditFolderViewVisible,
  setPermissionSettingVisible,
  setSharedByVisible,
  queryByPaging,
  setSelectedFolderData,
  fetchNewTemplateData
} from '../../flow/action';
import {
  TemplateDetail,
  Radios,
} from '../component';
import { getTeamUsers } from '../../flow/reselect';

class EmailTemplateDetail extends React.Component {
  isCurrentUser = () => {
    const { selectedUser, loginUser } = this.props;
    return loginUser.id === selectedUser.id;
  }

  render() {
    const {
      setEditFolderViewVisible,
      setPermissionSettingVisible,
      isPermissionSettingVisible,
      isSharedByVisible,
      queryByPaging,
      setSharedByVisible,
      setSelectedFolderData,
      selectedFolder,
      userFolders,
      sharedFolders,
      selectedUser,
      fetchNewTemplateData,
    } = this.props;

    const actionsLeft = (
      <Radios
        queryByPaging={queryByPaging}
        setSelectedFolderData={setSelectedFolderData}
        selectedUser={selectedUser}
        setSharedByVisible={setSharedByVisible}
      />
    );
    const actionsRight = (
      <Permission permission={PERMISSIONS.SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES_EDITMYFOLDERS}>
        <Button
          className="btn-ellipse email-theme-btn"
          size="small"
          onClick={() => setEditFolderViewVisible(true)}
        >
          <Icon type="edit" />
          <FormattedMessage id="page.emailTemplates.editFolders" />
        </Button>
      </Permission>
    );

    return (
      <Panel
        panelClasses="email-theme-panel"
        actionsLeft={actionsLeft}
        actionsRight={isSharedByVisible || !this.isCurrentUser() ? null : actionsRight}
      >
        <TemplateDetail
          setPermissionSettingVisible={setPermissionSettingVisible}
          isPermissionSettingVisible={isPermissionSettingVisible}
          isSharedByVisible={isSharedByVisible}
          queryByPaging={queryByPaging}
          setSelectedFolderData={setSelectedFolderData}
          selectedFolder={selectedFolder}
          userFolders={userFolders}
          sharedFolders={sharedFolders}
          fetchNewTemplateData={fetchNewTemplateData}
          isCurrentUser={this.isCurrentUser}
        />
      </Panel>
    );
  }
}

const mapStateToProps = ({ global, setup, loginUser }) => {
  const { emailTemplates } = setup;
  return {
    lang: global.language,
    teams: global.settings.teams,
    teamUsers: getTeamUsers({ emailTemplates }),
    loginUser,
    isEditFolderViewVisible: emailTemplates.ui.isEditFolderViewVisible,
    isPermissionSettingVisible: emailTemplates.ui.isPermissionSettingVisible,
    isSharedByVisible: emailTemplates.ui.isSharedByVisible,
    userFolders: emailTemplates.userFolders,
    sharedFolders: emailTemplates.sharedFolders,
    selectedFolder: emailTemplates.selectedFolder,
    selectedUser: emailTemplates.selectedUser,
  };
};

const mapDispatchToProps = {
  setTeams,
  updateUsers,
  setEditFolderViewVisible,
  setPermissionSettingVisible,
  setSharedByVisible,
  queryByPaging,
  setSelectedFolderData,
  fetchNewTemplateData
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailTemplateDetail);




// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/container/emailTemplateDetail.js